import { render } from "./DynamicResourcesFilter.vue?vue&type=template&id=1180f783&scoped=true"
import script from "./DynamicResourcesFilter.vue?vue&type=script&lang=js"
export * from "./DynamicResourcesFilter.vue?vue&type=script&lang=js"

import "./DynamicResourcesFilter.vue?vue&type=style&index=0&id=1180f783&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1180f783"

export default script